/**
 * As duas telas que existem SEM sessão.
 *
 * ── Por que isto é uma função, e não um `if` dentro do `index.tsx` ───────
 *
 * O app é uma página só, sem roteador: `App.tsx` decide tudo, e a primeira
 * coisa que ele faz é `if (!session) return <LoginPage />`. Quem chega por um
 * convite quase nunca tem conta — cairia no login e nunca veria o convite.
 *
 * Então o desvio acontece ANTES do `App`, e a regra que decide mora aqui, onde
 * dá para testar sem montar nada. Um `if` solto no `index.tsx` só se conferiria
 * abrindo o navegador.
 */
export type RotaPublica =
  | { tipo: 'convite'; token: string }
  | { tipo: 'sair'; token: string }
  | null;

/**
 * A tela de autorizar o conector de IA (15/09).
 *
 * Não é pública — ali só a dona da conta decide —, mas desvia ANTES do `App`
 * pelo mesmo motivo das outras: `App.tsx` mostra o painel inteiro, e quem
 * chega aqui veio do Claude ou do ChatGPT para responder uma pergunta só.
 *
 * O caminho é o que está configurado no painel do Supabase como
 * "Authorization Path". Se ele mudar lá, muda aqui — e o fluxo quebra em
 * silêncio se os dois discordarem.
 */
export const CAMINHO_DO_CONSENTIMENTO = '/oauth/consent';

export const rotaDeConsentimento = (pathname: string): boolean =>
  String(pathname ?? '').replace(/\/+$/, '') === CAMINHO_DO_CONSENTIMENTO;

/**
 * O token é validado por FORMATO aqui, e por valor no servidor.
 *
 * Não é segurança — é para `/convite/` sem token, ou `/convitepara/algo`, não
 * abrirem uma tela de convite que nunca vai carregar. O que autoriza é sempre
 * o servidor.
 */
const HEX = /^[0-9a-f]+$/;

export const rotaPublica = (pathname: string): RotaPublica => {
  const partes = String(pathname ?? '').split('/').filter(Boolean);
  if (partes.length !== 2) return null;

  const [secao, token] = partes;
  if (!token || !HEX.test(token)) return null;

  if (secao === 'convite') return { tipo: 'convite', token };
  if (secao === 'sair') return { tipo: 'sair', token };
  return null;
};
